/* @ngInject */
function auditService (AuditBaseService, ConnectorWebService, UploadService, CONSTANTS, Utils) {
  const service = {
    getAuditTemplates,
    getAudits,
    getAuditById,
    createAudit,
    deleteAudit,
    updateAudit,
    getAuditStatus,
    getAuditActivities,
    createAuditComment,
    editAuditComment,
    getAuditBriefing,
    getBriefingFieldsNonconformities,
    fillAuditBriefing,
    rateAuditBriefing,
    downloadAttachment,
    updateAuditBriefing,
    getAuditBriefingVersions,
    reminder,
    uploadSignatureFieldToS3,
    bindAuditBriefingToCampaign
  }
  return angular.extend({}, AuditBaseService, service)

  function getAuditTemplates (top, skip, search) {
    let url = CONSTANTS.URL_CUSTOMER_BRIEFINGS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    url = Utils.fnAddQueryToUrl(url, {
      type: 'AUDIT',
      search
    })

    return ConnectorWebService.get(url)
  }

  function getAudits (top, skip, params) {
    let url = CONSTANTS.URL_AUDITS
    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    url = Utils.fnAddQueryToUrl(url, params)
    return ConnectorWebService.get(url)
  }

  function getAuditById (id, params = {}) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID, [id])
    url = Utils.fnAddQueryToUrl(url, params)
    return ConnectorWebService.get(url)
  }

  function createAudit (payload) {
    return ConnectorWebService.post(CONSTANTS.URL_AUDITS, payload)
  }

  function deleteAudit (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID, [id])
    return ConnectorWebService.fnDelete(url)
  }

  function updateAudit (id, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID, [id])
    return ConnectorWebService.put(url, payload)
  }

  function getAuditStatus () {
    return ConnectorWebService.get(CONSTANTS.URL_AUDITS_STATUS)
  }

  function getAuditActivities (id, activityFilter) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_ACTIVITY, [id])
    if (activityFilter.comments && !activityFilter.activity) {
      url = Utils.fnAddQueryToUrl(url, { type: 'COMENT' })
    } else if (!activityFilter.comments && activityFilter.activity) {
      url = Utils.fnAddQueryToUrl(url, { type: 'ACTIVITY' })
    }
    return ConnectorWebService.get(url)
  }

  function createAuditComment (id, comment) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_COMMENTS, [id])
    return ConnectorWebService.post(url, { value: comment })
  }

  function editAuditComment (auditId, comment, commentId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_COMMENT_ID, [auditId, commentId])
    return ConnectorWebService.put(url, { value: comment })
  }

  function getAuditBriefing (id, params = {}) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_BRIEFING, [id])
    url = Utils.fnAddQueryToUrl(url, params)
    return ConnectorWebService.get(url)
  }

  function getBriefingFieldsNonconformities (id, version) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_BRIEFING_NONCONFORMITIES, [id])
    url = Utils.fnAddQueryToUrl(url, { version })
    return ConnectorWebService.get(url)
  }

  function getAuditBriefingVersions (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_BRIEFING_VERSIONS, [id])
    return ConnectorWebService.get(url)
  }

  function fillAuditBriefing (id, filledBriefing) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_BRIEFING, [id])
    return ConnectorWebService.post(url, filledBriefing)
  }

  function updateAuditBriefing (id, filledBriefing) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_BRIEFING, [id])
    return ConnectorWebService.put(url, filledBriefing)
  }

  function rateAuditBriefing (id, data) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_RATE, [id])
    return ConnectorWebService.post(url, data)
  }

  function downloadAttachment (attachmentId) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [attachmentId])
    url = Utils.fnAddQueryToUrl(url, { downloadModule: 'CHECKLIST' })

    return Utils.downloadFile(url)
  }

  function reminder (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_REMINDER, [id])
    return ConnectorWebService.post(url)
  }

  function uploadSignatureFieldToS3 (field) {
    if (field.type !== 'SIGNATURE' || !field.value) {
      return
    }

    const xml = field.value
    const xmlBlob = new Blob([new TextEncoder().encode(xml)])
    const fileObject = new File([xmlBlob], 'user-signature', {
      type: 'image/svg+xml'
    })

    return UploadService.uploadToS3(fileObject)
  }

  function bindAuditBriefingToCampaign (params = {}) {
    const { assetId, selectedCampaign } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID_BIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url, { campaignId: selectedCampaign })
  }
}

export { auditService }
